// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 898 ? "28efd8eb" : chunkId) + "." + {"348":"197a40c361940b64","561":"a1c7ae5de9d90002","898":"7cd9941df104d57b"}[chunkId] + ".js";
};